import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _334ca404 = () => interopDefault(import('../pages/bak/index.vue' /* webpackChunkName: "pages/bak/index" */))
const _3f351faa = () => interopDefault(import('../pages/page.vue' /* webpackChunkName: "pages/page" */))
const _b7955cc8 = () => interopDefault(import('../pages/news/news_detail.vue' /* webpackChunkName: "pages/news/news_detail" */))
const _94665eb6 = () => interopDefault(import('../pages/site/search.vue' /* webpackChunkName: "pages/site/search" */))
const _eb11cbe0 = () => interopDefault(import('../pages/bak/about/about_us.vue' /* webpackChunkName: "pages/bak/about/about_us" */))
const _a5338cac = () => interopDefault(import('../pages/bak/contact/contact_us.vue' /* webpackChunkName: "pages/bak/contact/contact_us" */))
const _249fae70 = () => interopDefault(import('../pages/bak/service/pro_list.vue' /* webpackChunkName: "pages/bak/service/pro_list" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/bak",
    component: _334ca404,
    name: "bak"
  }, {
    path: "/page",
    component: _3f351faa,
    name: "page"
  }, {
    path: "/news/news_detail",
    component: _b7955cc8,
    name: "news-news_detail"
  }, {
    path: "/site/search",
    component: _94665eb6,
    name: "site-search"
  }, {
    path: "/bak/about/about_us",
    component: _eb11cbe0,
    name: "bak-about-about_us"
  }, {
    path: "/bak/contact/contact_us",
    component: _a5338cac,
    name: "bak-contact-contact_us"
  }, {
    path: "/bak/service/pro_list",
    component: _249fae70,
    name: "bak-service-pro_list"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
